//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex';
import ButtonBlock from 'components/blocks/Button.vue'
import TextLink from 'components/blocks/TextLink.vue'

export default {
  block: ['pressReleases'],
  props: ['data'],
  components: {
    ButtonBlock,
    TextLink,
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
  },
  data() {
    return {
      prIndex: this.data.startIndex-1,
      pressReleases: [],
      loadedContent: {},
    }
  },
  methods: {
    moreButtonClicked() {
      this.loadContent();
    },
    loadContent() {
      if (this.data.pressReleases.length < 1)
        return;

      let loadedPressReleases = 0;
      let newContent = {};

      // Load (maximum) 3 more pressreleases as long as prIndex is not 0
      while (this.prIndex >= 0 && loadedPressReleases <= 2) {

        newContent = this.data.pressReleases[this.prIndex];

        loadedPressReleases++;
        this.prIndex--;
        this.pressReleases.push(newContent);
      }
    },
  },
  mounted() {
    this.loadContent();
  },
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/PressReleases.vue